import { logImpressionEvent } from '@office-start/instrumentation-service';
import { getIsPageVisible } from '@office-start/page-visibility-service';
import { mark } from '@office-start/performance-service';
import { logFeature, logImpression, logUserAction, } from '@office-start/telemetry-service';
var VisualsArea = 'Visuals';
var VisualsSubArea = 'VisualUserSettings';
var VisualsFeatureName = "Visuals" /* KnownFeatureNames.Visuals */;
export var logUserSettingsImpression = function () {
    logImpression({
        area: VisualsArea,
        subArea: VisualsSubArea,
        eventName: "VisualUserSettings_Impression" /* KnownImpressionInstrumentationEvents.VisualUserSettings */,
    });
    // Log to Aria
    var params = {};
    params["Area" /* InstrumentationParam.Area */] = VisualsSubArea;
    logImpressionEvent("VisualUserSettings_Impression" /* KnownImpressionInstrumentationEvents.VisualUserSettings */, params);
    if (getIsPageVisible()) {
        mark("".concat(VisualsSubArea, "_Paint"));
    }
};
export var logUserThemeChange = function (eventName, params, _a) {
    var _b = _a === void 0 ? {
        area: VisualsArea,
        subArea: VisualsSubArea,
        featureName: VisualsFeatureName,
    } : _a, area = _b.area, subArea = _b.subArea, featureName = _b.featureName;
    logFeature({
        area: area,
        subArea: subArea,
        eventName: eventName,
        featureName: featureName,
        params: {
            ThemeId: params.id,
            ThemeMode: params.mode,
            PreferHarmonyTheme: params.preferHarmonyTheme ? 1 : 0,
        },
    });
    logUserAction({
        id: eventName,
        area: area,
        result: 'Select',
        target: 'VisualUserSettings',
        type: 'Click',
    });
};
//# sourceMappingURL=userSettingsTelemetry.js.map